import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Package, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Register() {
    const { user, register } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    if (user) return <Navigate to="/" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        const res = await register(email, password, name);
        setBusy(false);
        if (!res.ok) {
            toast.error(res.error);
            return;
        }
        toast.success("Compte créé !");
        navigate("/");
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6">
            <Card className="w-full max-w-md border-border">
                <CardContent className="p-8 space-y-6">
                    <div className="flex items-center gap-3">
                        <div className="h-9 w-9 rounded-md bg-primary text-primary-foreground flex items-center justify-center">
                            <Package weight="duotone" size={20} />
                        </div>
                        <div className="font-display text-xl font-bold">ScanBox</div>
                    </div>
                    <div>
                        <p className="overline">Inscription</p>
                        <h2 className="font-display text-3xl font-bold mt-2 tracking-tight">Créez votre compte</h2>
                        <p className="text-muted-foreground text-sm mt-2">
                            Démarrez en moins de 30 secondes — aucune carte bancaire requise.
                        </p>
                    </div>

                    <form className="space-y-4" onSubmit={submit}>
                        <div className="space-y-2">
                            <Label htmlFor="name">Nom (optionnel)</Label>
                            <Input
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Votre nom"
                                data-testid="register-name"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="vous@exemple.com"
                                data-testid="register-email"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="password">Mot de passe (6 caractères min.)</Label>
                            <Input
                                id="password"
                                type="password"
                                required
                                minLength={6}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="register-password"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={busy}
                            className="w-full bg-primary hover:bg-primary/90"
                            data-testid="register-submit"
                        >
                            {busy ? "Création…" : "Créer mon compte"}
                            <ArrowRight size={16} className="ml-2" />
                        </Button>
                    </form>

                    <div className="text-sm text-muted-foreground text-center">
                        Déjà inscrit ?{" "}
                        <Link to="/login" className="text-primary font-semibold hover:underline" data-testid="link-login">
                            Se connecter
                        </Link>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
